import { inZone } from './companyDate';

// What the customer card, the edit form and the Subscribe button say about a
// customer whose email is off (server/services/customerUnsubscribe.js,
// migration 112). email_unsubscribed_at and email_unsubscribe_source arrive
// with GET /api/customers: 'link' when the customer used the unsubscribe link
// in an email, 'contractor' when the box was unticked here. Rows turned off
// before migration 112 have neither, and show no date.

const dateOf = (at, timezone) => new Date(at).toLocaleDateString(
  'en-US', inZone(timezone, { month: 'short', day: 'numeric', year: 'numeric' })
);

// The card line, or null when email is on.
export const unsubscribedLine = (customer, timezone) => {
  if (!customer || customer.email_subscribed !== false) return null;
  return customer.email_unsubscribed_at
    ? `Unsubscribed from email on ${dateOf(customer.email_unsubscribed_at, timezone)}`
    : 'Unsubscribed from email';
};

// True when the customer turned email off themselves, by the link.
export const unsubscribedThemselves = (customer) => Boolean(customer)
  && customer.email_subscribed === false && customer.email_unsubscribe_source === 'link';

// The edit form's note under an unticked box, or null.
export const selfUnsubscribedNote = (customer, timezone) => {
  if (!unsubscribedThemselves(customer)) return null;
  const when = customer.email_unsubscribed_at ? ` on ${dateOf(customer.email_unsubscribed_at, timezone)}` : '';
  return `This customer unsubscribed themselves${when}. Tick it only if they have asked to receive your email again.`;
};

// The confirm before the recipient list's Subscribe button turns email back on.
export const resubscribeConfirmText = (customer, timezone) => {
  const name = [customer.first_name, customer.last_name].filter(Boolean).join(' ') || 'this customer';
  const who = unsubscribedThemselves(customer)
    ? `${name} unsubscribed themselves${customer.email_unsubscribed_at ? ` on ${dateOf(customer.email_unsubscribed_at, timezone)}` : ''}.`
    : `${name} is unsubscribed from your email.`;
  return `${who} Turn their email back on only if they have asked you to. Turn it back on now?`;
};
